import React, { createContext } from "react";
import useLoadFBScript from "./hooks/useLoadFBScript";
;
var FacebookOAuthContext = createContext(null);
var FacebookOAuthProvider = function (_a) {
    var appId = _a.appId, appVersion = _a.appVersion, onScriptLoadSuccess = _a.onScriptLoadSuccess, onScriptLoadError = _a.onScriptLoadError, children = _a.children;
    useLoadFBScript({ onScriptLoadSuccess: function () {
            window.fbAsyncInit = function () {
                window.FB.init({
                    appId: appId,
                    version: appVersion,
                    localStorage: false,
                    xfbml: true,
                });
                window.FB.AppEvents.logPageView();
            };
            onScriptLoadSuccess === null || onScriptLoadSuccess === void 0 ? void 0 : onScriptLoadSuccess();
        }, onScriptLoadError: onScriptLoadError });
    return (React.createElement(FacebookOAuthContext.Provider, { value: null }, children));
};
export default FacebookOAuthProvider;
